// Al crear una guía o preguía se limpia todo el formulario MENOS el origen:
// con 1 sola oficina siempre es la misma, y con varias se conserva la que
// eligió el usuario (si no la quiere, la quita a mano con la X del combo).
// Compartido por CreateShipmentV2 y CreatePreShipment para que la regla no se
// desincronice entre las dos vistas.
export const resetValuesKeepingOrigin = <T extends { origin: unknown }>(
  initialValues: T,
  submittedValues: T
): T => ({
  ...initialValues,
  origin: submittedValues.origin,
})
